import {copilotFeatureFlags} from '../utils/copilot-feature-flags'
import {AgentAutocomplete} from './autocomplete/AgentAutocomplete'
import {UnifiedAutocomplete, type UnifiedAutocompleteProps} from './autocomplete/UnifiedAutocomplete'

export function Autocomplete({children, onSelectReference}: UnifiedAutocompleteProps) {
  return copilotFeatureFlags.chatAutocomplete ? (
    <UnifiedAutocomplete onSelectReference={onSelectReference}>{children}</UnifiedAutocomplete>
  ) : (
    <AgentAutocomplete>{children}</AgentAutocomplete>
  )
}

try{ Autocomplete.displayName ||= 'Autocomplete' } catch {}